module.exports = __webpack_public_path__ + "assets/share.fb6cd482.svg";